import type { PayloadFormatter } from '../shared/types';

export const formatPythonPayload: PayloadFormatter = (args) => {
  if (args?.script) {
    return `\`\`\`python\n${args.script}\n\`\`\``;
  }
  return null;
};
